// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"f2fd9053","472":"ff88080e","703":"2de3ceca","745":"f6640751","955":"d8bdef16"}[chunkId] + ".css";
};